import { NgModule } from '@angular/core'
import { CmsComponentsBaseModule } from '../../../components/cms-components-base.module'

@NgModule({
  imports: [
    CmsComponentsBaseModule
  ],
})
export class MbCategoryNavigationLinkModule {}
